import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { HTML_ATTRIBUTE_COOKIE_IDS, HTML_ATTRIBUTE_BLOCKER_ID } from ".";
import { getOtherOptionsFromWindow } from "../../utils";
/**
 * Read all HTML elements and check, if they can be enabled by the consent cookies.
 */

function getContentBlockerNodes(cookies) {
  var result = [];
  var nodes = Array.prototype.slice.call(document.querySelectorAll("[".concat(HTML_ATTRIBUTE_COOKIE_IDS, "]")));

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      allBlocker = _getOtherOptionsFromW.blocker;

  var _iterator = _createForOfIteratorHelper(nodes),
      _step;

  try {
    var _loop = function _loop() {
      var _allBlocker$filter;

      var node = _step.value;
      var blocker = (_allBlocker$filter = allBlocker.filter(function (_ref) {
        var id = _ref.id;
        return id === +node.getAttribute(HTML_ATTRIBUTE_BLOCKER_ID);
      })) === null || _allBlocker$filter === void 0 ? void 0 : _allBlocker$filter[0];
      var required = node.getAttribute(HTML_ATTRIBUTE_COOKIE_IDS).split(",").map(Number); // Check if consent is given for required cookies

      var requiredCheck = required.map(function (requiredId) {
        var _iterator2 = _createForOfIteratorHelper(cookies),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var id = _step2.value.cookie.id;

            if (id === requiredId) {
              return true;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return false;
      });
      result.push({
        node: node,
        consent: requiredCheck.indexOf(false) === -1,
        blocker: blocker
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

export { getContentBlockerNodes };